import React from 'react';
import { ExternalLink } from 'lucide-react';
import { parseTextWithLinks, formatUrlForDisplay } from '../../utils/linkParser';

/**
 * Component to render text with embedded clickable link buttons
 * @param {Object} props
 * @param {string} props.text - The text content that may contain URLs
 * @param {string} props.className - Additional CSS classes for the container
 * @param {string} props.textClassName - CSS classes for text segments
 * @param {string} props.linkClassName - CSS classes for link buttons
 */
const RichTextRenderer = ({ 
  text, 
  className = '', 
  textClassName = 'text-gray-700', 
  linkClassName = '' 
}) => {
  const segments = parseTextWithLinks(text);

  if (!segments || segments.length === 0) {
    return (
      <span className={`${textClassName} ${className}`}>
        {text || ''}
      </span>
    );
  }

  const handleLinkClick = (url) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <span className={`${className}`}>
      {segments.map((segment, index) => {
        if (segment.type === 'text') {
          return (
            <span key={index} className={textClassName}>
              {segment.content}
            </span>
          );
        } else if (segment.type === 'link') {
          return (
            <React.Fragment key={index}>
              <button
                onClick={() => handleLinkClick(segment.url)}
                className={`
                  inline-flex items-center gap-1 px-3 py-1 mx-1
                  bg-Color-Brand-Yellow/10 hover:bg-Color-Brand-Yellow/20 
                  text-gray-600
                  border border-Color-Brand-Yellow/30 hover:border-Color-Brand-Yellow/50
                  rounded-md text-sm font-medium
                  transition-all duration-200
                  focus:outline-none focus:ring-2 focus:ring-Color-Brand-Blue focus:ring-offset-1
                  ${linkClassName}
                `}
                title={`Open ${segment.url}`}
                type="button"
              >
                <ExternalLink className="w-3 h-3" />
                {formatUrlForDisplay(segment.content, 30)}
              </button>
            </React.Fragment>
          );
        }
        return null;
      })}
    </span>
  );
};

export default RichTextRenderer;